"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const axios_1 = __importDefault(require("axios"));
let DashboardBanner = class DashboardBanner extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.switchLoading = false;
    }
    get isBannerVisibility() {
        return this.switchDate ? this.hasDatePassed(this.switchDate) : true;
    }
    async bannerAction() {
        await this.switchDashboard();
        location.reload();
    }
    async switchDashboard() {
        this.switchLoading = true;
        try {
            await axios_1.default.get('/dashboard/switch');
        }
        catch (error) {
            console.error(error.response);
        }
    }
    hasDatePassed(date) {
        const givenDate = new Date(date.replace(" ", "T"));
        const nowDate = new Date();
        const oneWeekInMilliseconds = 7 * 24 * 60 * 60 * 1000;
        const differenceInMilliseconds = nowDate.getTime() - givenDate.getTime();
        return differenceInMilliseconds < oneWeekInMilliseconds;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'Example title' })
], DashboardBanner.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'Example subtitle' })
], DashboardBanner.prototype, "subtitle", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], DashboardBanner.prototype, "switchDate", void 0);
DashboardBanner = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Button: bmk_ui_framework_1.Button, ArrowUpRight: lucide_vue_next_1.ArrowUpRight }
    })
], DashboardBanner);
exports.default = DashboardBanner;
